import React from 'react';
import { Sun, Moon, MonitorSmartphone } from 'lucide-react';
import { useThemeMode } from './themeMode';

const NEXT = { light: 'dark', dark: 'auto', auto: 'light' };
const LABEL = { light: 'Tema claro', dark: 'Tema oscuro', auto: 'Tema del sistema' };
const ICON = { light: Sun, dark: Moon, auto: MonitorSmartphone };

/** Botón que alterna claro → oscuro → automático. */
export default function ThemeToggle({ style, size = 16 }) {
  const [mode, setMode] = useThemeMode();
  const Icon = ICON[mode];
  return (
    <button
      type="button"
      className="ui-hover"
      onClick={() => setMode(NEXT[mode])}
      title={`${LABEL[mode]} · clic para cambiar a ${LABEL[NEXT[mode]].toLowerCase()}`}
      aria-label={`${LABEL[mode]}. Cambiar a ${LABEL[NEXT[mode]].toLowerCase()}`}
      style={style}
    >
      <Icon size={size} strokeWidth={2} />
    </button>
  );
}
